import CoreServices from './coreServices'
import { PAYMENT } from '../constants/services'
import axios from 'axios'

class PaymentServices extends CoreServices {
  async purchaseUnlimit(args) {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/payments/unlimit-verify`, args, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })
      let data = await response.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async purchase(packageId) {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/payments`, { packageId: packageId }, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })
      let data = await response.data.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async dimocoPurchase(args) {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/payments`, args, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          
        },
      })
      let data = await response.data

      return data.data
    } catch (error) {
      return error.response.data
    }
  }

  async getPackages(category = 'premium') {
    try {
      let response = await axios.get(`${this.apiEnpointV1}/payments/packages?type=${category}&platform=desktop`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          
        },
      })
      let data = await response.data.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async getSubscriptions() {
    try {
      let response = await axios.get(`${this.apiEnpointV1}/subscriptions`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          
        },
      })
      let data = await response.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async cancelSubscription(subscriptionId) {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/subscriptions/${subscriptionId}/cancel`, {}, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          
        },
      })
      let data = await response.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async getPackageIntent(args) {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/payments/intents`, { ...args, platform: 'web', source: 'original' }, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          
        },
      })
      let data = await response.data.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async clickLink(args) {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/referrals/click`, args, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          
        },
      })
      let data = await response.data.data

      return data
    } catch (error) {
      return { error }
    }
  }
}

export default new PaymentServices(PAYMENT.BASE)
